module.exports = __webpack_public_path__ + "img/messengerIcon.acb8fbd4.svg";